/* eslint-disable react/no-array-index-key */

/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import PropTypes from 'prop-types';
import { TickIcon, TrustPilotRatingLogo, DomesticAndGeneralLogo } from '@sainsburys-tech/bolt-icons';
import ProductSummary from '../ProductSummary/ProductSummary';
import careTypes from '../../config/careTypes';
import * as Styled from './ProductCareContent.styles';

var ProductCareContent = function ProductCareContent(_ref) {
  var hostPartNumber = _ref.hostPartNumber,
      hostProductName = _ref.hostProductName,
      hostPrice = _ref.hostPrice,
      quantity = _ref.quantity,
      warrantyName = _ref.warrantyName,
      warrantyPrice = _ref.warrantyPrice,
      warrantyItem = _ref.warrantyItem,
      onlyWarranty = _ref.onlyWarranty,
      dataTest = _ref.dataTest,
      careType = _ref.careType,
      isMonthly = _ref.isMonthly;
  var totalPrice = quantity * (parseFloat(hostPrice) + (!isMonthly ? parseFloat(warrantyPrice) : 0));
  var displayProductSummary = !warrantyItem;
  var hostDetails = {
    partNumber: hostPartNumber,
    productName: hostProductName,
    productPrice: hostPrice,
    hostProduct: true,
    quantity: quantity
  };
  var warrantyDetails = {
    partNumber: null,
    productName: warrantyName,
    productPrice: warrantyPrice,
    hostProduct: false,
    quantity: quantity
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ProductSummary, {
    hostDetails: hostDetails,
    warrantyDetails: warrantyDetails,
    totalPrice: totalPrice,
    displayProductSummary: displayProductSummary,
    onlyWarranty: onlyWarranty,
    isMonthly: isMonthly,
    dataTest: dataTest
  }), /*#__PURE__*/React.createElement(Styled.ContentContainer, {
    "data-test": "".concat(dataTest, "-").concat(careType)
  }, /*#__PURE__*/React.createElement(Styled.ContentTitle, {
    noMarginBottom: true
  }, careTypes[careType].intro), /*#__PURE__*/React.createElement("ul", null, careTypes[careType].benefits.map(function (benefit, key) {
    return /*#__PURE__*/React.createElement(Styled.ContentListItem, {
      key: "".concat(benefit, "_").concat(key)
    }, /*#__PURE__*/React.createElement(Styled.TickIconContainer, null, /*#__PURE__*/React.createElement(TickIcon, {
      height: "22px",
      width: "22px"
    })), /*#__PURE__*/React.createElement(Styled.ContentListText, {
      dangerouslySetInnerHTML: {
        __html: benefit
      }
    }));
  })), /*#__PURE__*/React.createElement(Styled.CareProviderContainer, null, /*#__PURE__*/React.createElement(Styled.DGLogoContainer, null, /*#__PURE__*/React.createElement(Styled.ProviderText, null, careTypes[careType].provider), /*#__PURE__*/React.createElement(DomesticAndGeneralLogo, {
    height: "auto",
    width: 75,
    "aria-hidden": "true"
  })), /*#__PURE__*/React.createElement(Styled.TrustPilotLogoContainer, null, /*#__PURE__*/React.createElement(TrustPilotRatingLogo, {
    height: "auto",
    width: 200,
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement(Styled.TrustPilotText, null, careTypes[careType].trustPilotRating))), /*#__PURE__*/React.createElement(Styled.LegalTitle, null, "Key exclusions:"), /*#__PURE__*/React.createElement(Styled.LegalText, null, careTypes[careType].keyExclusions), /*#__PURE__*/React.createElement(Styled.LegalTitle, null, "Demands and Needs:"), /*#__PURE__*/React.createElement(Styled.LegalText, null, careTypes[careType].demandsAndNeeds), careTypes[careType].compareProductInsurance && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Styled.LegalTitle, null, "Compare product insurance:"), /*#__PURE__*/React.createElement(Styled.LegalText, null, careTypes[careType].compareProductInsurance, /*#__PURE__*/React.createElement("a", {
    href: "/help/argos-care/"
  }, "click here")))));
};

ProductCareContent.propTypes = {
  /**
   * The part number of the "host product" - the product the user is buying warranty for
   */
  hostPartNumber: PropTypes.string.isRequired,

  /**
   * The product name  of the "host product" - the product the user is buying warranty for
   */
  hostProductName: PropTypes.string.isRequired,

  /**
   * The price of the "host product" - the product the user is buying warranty for
   */
  hostPrice: PropTypes.number.isRequired,

  /**
   * Hides the product details section in the drawer, showing just the legal content
   */
  warrantyItem: PropTypes.bool,

  /**
   * The quantity of the "host product" - the product the user is buying warranty for
   */
  quantity: PropTypes.number,

  /**
   * The product name of the warranty product
   */
  warrantyName: PropTypes.string.isRequired,

  /**
   * The price of the warranty product
   */
  warrantyPrice: PropTypes.number.isRequired,

  /**
   * String to specify the copy used for each care type. Required in title case as it's directly used in the modal
   */
  careType: PropTypes.oneOf(['breakdown_care', 'epc_care', 'replacement_care', 'furniture_care', 'monthly_care', 'monthly_care_excess', 'mobile_care']).isRequired
};
ProductCareContent.defaultProps = {
  quantity: 1,
  dataTest: 'product-care'
};
export default ProductCareContent;